export default {"src":"/_next/static/media/PPS.60370983.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};